/**
 * Colour helpers. Palette tokens are a mix of hex (#D97706) and rgba() strings, so appending a hex alpha suffix
 * ("#D9770699") works for some tokens and silently produces invalid CSS for others. Always go through withAlpha.
 */

/** `color` at the given opacity (0-1). Understands #rgb, #rrggbb, #rrggbbaa, rgb() and rgba(); anything else is returned as is. */
export function withAlpha(color: string, alpha: number): string {
  const a = Math.min(1, Math.max(0, alpha));
  const value = color.trim();

  const hex = /^#([0-9a-f]{3,8})$/i.exec(value);
  if (hex) {
    let h = hex[1];
    if (h.length === 3 || h.length === 4) h = h.split('').map(ch => ch + ch).join('');
    if (h.length === 6 || h.length === 8) {
      const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
      return `rgba(${r},${g},${b},${+a.toFixed(3)})`;
    }
  }

  const rgb = /^rgba?\(([^)]+)\)$/i.exec(value);
  if (rgb) {
    const parts = rgb[1].split(',').map(p => p.trim());
    if (parts.length >= 3) return `rgba(${parts[0]},${parts[1]},${parts[2]},${+a.toFixed(3)})`;
  }
  return color;
}
